var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDruken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99984 18.9584C5.05229 18.9584 1.0415 14.9477 1.0415 10.0001C1.0415 5.05253 5.05229 1.04175 9.99984 1.04175C14.9474 1.04175 18.9582 5.05253 18.9582 10.0001C18.9582 14.9477 14.9474 18.9584 9.99984 18.9584ZM12.744 6.07746L9.99967 8.82158L7.25579 6.07789L6.07731 7.25644L8.82109 10.0001L6.07731 12.7437L7.25579 13.9222L9.99967 11.1785L12.744 13.9227L13.9224 12.7441L11.1782 10.0001L13.9224 7.25601L12.744 6.07746Z",
    fill: "#FF4444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDruken);
export default __webpack_public_path__ + "static/media/druken.c1c00e750759039b7e0bfd241435979e.svg";
export { ForwardRef as ReactComponent };